<template>
<div class="card feed" :class="is_main ? 'main' : ''"  :id="'feed-'+feed.id">
    <div class="card-header" :style="'background:'+(feed.color ? feed.color : '#01a0c7')+';'+(is_main ? 'top: 7.75rem;' : '')" :class="$options.filters.text_color_class(feed.color ? feed.color : '#01a0c7')+' '+(is_main ? 'sticky-top' : '')">
        <h3 class="card-title py-1 my-0">
            {{feed.keyword}}
        </h3>
        <div class="card-tools">
            <span v-if="monitoring" class="blink d-inline-block float-left">
                {{translate('messages.monitoring')}} 
            </span>
            <button class="btn btn-tool no-shadow" @click="toggleMonitor" v-tooltip:bottom="translate('messages.activate_deactivate_monitoring')" data-toggle="tooltip">
                <radar :monitoring="monitoring"/>
            </button>
        </div>
    </div>
    <div class="card-toolbar card-header p-1 text-right">
        <div class="m-1 float-left">
            <span class="mx-2" v-if="feed.active_submission" v-tooltip:bottom="translate('messages.activate_submission')" data-toggle="tooltip"><i class="fab fa-whatsapp fa-lg"></i></span>
            <span class="mx-2" v-if="feed.type == 'smart'" v-tooltip:bottom="translate('messages.smart_feed')" data-toggle="tooltip"><i class="wi wi-sparkle fa-lg"></i></span>
            <span class="mx-2" v-if="feed.advanced_search" v-tooltip:bottom="translate('messages.advanced_search_active')" data-toggle="tooltip"><i class="wi wi-advanced-search fa-lg"></i></span>
        </div>

        <button type="button" class="btn btn-default btn-sm" @click="generatePDF()" :disabled="generating_pdf || !entries.length">
            <i class="fas fa-download"></i> <span v-if="!generating_pdf">{{translate('messages.download')}}</span><span v-else>{{translate('messages.downloading')}}</span>
        </button>
        <button class="btn btn-default btn-sm" :class="$root.app_config.dark_mode ? 'white' : ''" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand fa-lg" style="vertical-align: middle;"></i></button>
    </div>
    <!-- /.card-header -->
    <div class="card-body px-0" :id="'feed-'+feed.id+'-entries'">
        <div v-if="feed.type=='smart' && entries.length" style="overflow: hidden">
            <line-chart ref="sentiment_overview_chart" v-if="feed.type=='smart'" :chart-id="'feed-sentiment-overview-chart-'+feed.id" :chartData="sentimentOverviewDataCollection.chart_data" :options="sentimentOverviewDataCollection.chart_options" :styles="sentimentOverviewChartStyles" />
            <hr>
        </div>
        <div v-for="(entry, index) in entries" :key="'entry-'+index+'-'+entry.id" class="px-3">
            <div class="text-capitalize"><i class="far fa-calendar"></i> {{entry.date | localDateNoHour}}</div>
            <div><a :href="entry.permalink" target="blank">{{entry.title}}</a></div>
            <div v-if="feed.type=='smart' && entry.sentiment">
                <span class="badge" :class="'badge-'+$options.filters.color_class(entry.sentiment)">
                    {{translate('messages.'+entry.sentiment)}}
                </span>
            </div>
            <hr>
        </div>
        <div v-if="!loading && !entries.length" class="alert alert-warning">
            <h5><i class="icon fas fa-exclamation-triangle"></i> {{translate('messages.empty_results')}}</h5>
            {{translate('messages.empty_results_message')}}.
        </div>
    </div>
    <div v-if="loading" class="overlay dark">
        <i class="fas fa-sync fa-spin fa-2x"></i>
    </div>
</div>
</template>
 
<script>
import LineChart from '../charts/LineChart.js'
import moment from 'moment-timezone';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.addVirtualFileSystem(pdfFonts);

export default {
    props: ['feed', 'is_main'],
    components: {
      LineChart
    },
    data () {
        return {
            entries : [],
            loading : true,
            timer: null,
            monitoring: false,
            generating_pdf: false,
            sentimentOverviewDataCollection : {group_by: 'day'},
            sentimentOverviewChartStyles: {height: '200px', width: '100%'},
        }
    },
    methods: {
        loadEntries(){
            axios.get("/api/feed/entries/"+this.feed.id).then(({ data }) => {
                var entries = data.data;
                if(JSON.stringify(this.entries)!=JSON.stringify(entries)){
                    this.entries = entries;
                }
                if(this.feed.type == 'smart') this.renderSentimentOverviewChart('day');
                if(this.is_main){
                    var $feed_row = $('#feed-'+this.feed.id).closest('.row');
                    var card_body_height = $feed_row.innerHeight() - ($feed_row.find('.card-header').first().innerHeight() + $feed_row.find('.card-toolbar').first().innerHeight());
                    this.$root.$emit('updateFeedCardHeight', this.feed.id, card_body_height+'px');
                }
                this.loading = false;
            });
        },
        toggleMonitor(){
            this.monitoring = !this.monitoring;
            if(this.monitoring){
                this.timer = setInterval(function(){
                    this.loadEntries();
                }.bind(this), 60 * 1000);
            }else{
                clearInterval(this.timer);
            }
        },
        async generatePDF(){
            if(!this.entries.length) return;
            this.$Progress.start();
            this.generating_pdf = true;
            var docDefinition = {
                content: [
                    {
                        columns: [
                            { image: 'user_photo', width: 80},
                            {
                                stack: [
                                    {text: 'World Eye Monitor', alignment: 'left', fontSize: 20, bold: true},
                                    {text: this.translate('messages.feed')+': '+this.feed.keyword, alignment: 'left', fontSize: 16, decoration: 'underline', margin: [0,5,0,0]},
                                    {text: this.feed.advanced_search ? this.translate('messages.advanced_search_active') : '', alignment: 'left', fontSize: 10, margin: [0,3,0,0]},
                                    {text: this.feed.type == 'smart' ? this.translate('messages.smart_feed') : '', alignment: 'left', fontSize: 10, margin: [0,3,0,0]},
                                ],
                                width : '*'
                            },
                            { text: moment().format('dddd DD MMMM YYYY HH:mm'), alignment: 'right', width: 'auto', noWrap: true },
                        ],
                        columnGap: 12,
                        margin: [-30,-30,-30,15]
                    }
                ],
                images: {
                    logo: window.location.origin+'/images/logo.png',
                    user_photo: window.location.origin+user.photo
                }
            };
            if(this.feed.type == 'smart'){
                var styles = this.sentimentOverviewChartStyles;
                this.sentimentOverviewChartStyles = {height: '300px', width: '800px'};
                this.renderSentimentOverviewChart('day');
                await new Promise(resolve => setTimeout(resolve, 500));
                var canvas = this.$refs.sentiment_overview_chart.$refs.canvas;
                var imageData = canvas.toDataURL(this.$root.app_config.dark_mode ? 'image/jpeg' : 'image/png');
                docDefinition.content.push({image: imageData, margin: [0,3,0,15], width: 500, alignment: 'center'});
                this.sentimentOverviewChartStyles = styles;
                this.renderSentimentOverviewChart('day');
            }
            this.entries.forEach(entry => {
                docDefinition.content.push({ text: entry.title, bold: true});
                if(this.feed.type=='smart'){
                    let color = 'black';
                    let text = '';
                    if(entry.sentiment == 'positive'){
                        color = '#28A745';
                        text = this.translate('messages.positive');
                    }else if(entry.sentiment == 'negative'){
                        color = '#DC3545';
                        text = this.translate('messages.negative');
                    }
                    docDefinition.content.push({text: text, fontSize: 10, margin: [0,2,0,0], color: color});
                }
                docDefinition.content.push({text: translate('messages.date')+': '+this.$options.filters.localDateNoHour(entry.date), fontSize: 10, margin: [0,2,0,5]});
                docDefinition.content.push({text: entry.permalink, fontSize: 11, italics: true, margin: [0,0,0,20]},);
            });
            var v = this;
            pdfMake.createPdf(docDefinition).download(this.feed.keyword.substring(0, 25).replace(/\s/g, '_')+'_feed_'+moment().format('DDMMYYY')+'.pdf', function(){
                v.$Progress.finish();
                v.generating_pdf = false;
            });
        },
        renderSentimentOverviewChart(group_by = 'day'){
            var grouped_entries = {};
            var time_format = 'YYYY-MM-DD';
            switch(group_by){
                case 'year':
                    time_format = 'YYYY';
                    break;
                case 'month':
                    time_format = 'YYYY-MM';
                    break;
                case 'day':
                default:
                    time_format = 'YYYY-MM-DD';
                    break;
            }
            this.entries.forEach((entry) => {
                if(!entry.sentiment) return;
                let date = moment.utc(entry.date, 'YYYY-MM-DD HH:mm:ss +00000');
                let date_key = date.tz(this.$root.app_config.timezone).format(time_format);
                grouped_entries[entry.sentiment] = grouped_entries[entry.sentiment] || [];
                grouped_entries[entry.sentiment][date_key] = grouped_entries[entry.sentiment][date_key] || 0;
                grouped_entries[entry.sentiment][date_key]++;
            });

            var datasets = [];
            Object.keys(grouped_entries).forEach((sentiment) => {
                var data = [];
                Object.keys(grouped_entries[sentiment]).forEach((date) => {
                    data.push({x: date, y: grouped_entries[sentiment][date]})
                });

                datasets.push({
                    label: this.translate('messages.'+sentiment),
                    data: data,
                    borderColor: this.$options.filters.sentiment_color(sentiment, 1),
                    backgroundColor: this.$options.filters.sentiment_color(sentiment, 0.4),
                    fill: true,
                    tension: 0
                });
            });

            this.sentimentOverviewDataCollection = {
                group_by : group_by,
                chart_data: {
                    datasets: datasets
                },
                chart_options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales:     {
                        xAxes: [{
                            type:       "time",
                            time:       {
                                unit: group_by,
                                format: time_format,
                                tooltipFormat: 'll'
                            },
                            scaleLabel: {
                                display:     true,
                                labelString: translate('messages.date'),
                            },
                            gridLines: {
                                color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.2)',
                            },
                            ticks:{
                                fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                            }
                        }],
                        yAxes: [{
                            scaleLabel: {
                                display:     true,
                                labelString: translate('messages.mentions'),
                            },
                            gridLines: {
                                color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.2)',
                            },
                            ticks: {
                                fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                            }
                        }]
                    },
                    legend: {
                        labels: {
                            fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                        }
                    },
                    elements: {
                        line: {
                            tension: 0.3
                        }
                    },
                    plugins: {
                        filler: {
                            propagate: true
                        }
                    }
                },
            }
        },
    },
    mounted() {
        this.$root.$on('updateFeedCardHeight', (id, cardHeight) => {
            if(id != this.feed.id) return;
            $('#feed-'+id).find('>.card-body').css('height', cardHeight);
        });
    },
    created() {
        this.loadEntries();
    },
    beforeDestroy() {
        if(this.timer) clearInterval(this.timer);
    },
    watch: {
        entries(){
            this.$forceUpdate();
        }
    }
}
</script>